import React, { FC } from 'react';

import { IInformationColumn } from './information-list.interface';
import styles from './information-list.module.scss';

import { Text, Util } from 'views/components';

interface IInformationListElement {
  id: number | string;
  [key: string]: any;
}

interface InformationListProps<T> {
  columnsData: IInformationColumn<T>[];
  element: IInformationListElement;
  width?: string;
}

const InformationList: FC<InformationListProps<any>> = props => {
  const { columnsData, element, width } = props;
  return (
    <ul className={styles.list}>
      {columnsData.map(colName => (
        <li key={colName.key} style={{ width }}>
          <Util marginBottom="0.25rem">
            <Text variant="label">{colName.title}</Text>
          </Util>
          <div className={styles.render}>
            {element[colName.dataIndex] ? (
              <>
                {colName.render ? colName.render() : null}
                {colName.renderName ? (
                  colName.renderName(element[colName.dataIndex].name)
                ) : (
                  <Text>{element && element[colName.dataIndex].name}</Text>
                )}
                {!colName.render && !colName.renderName && (
                  <Text>{element && element[colName.dataIndex]}</Text>
                )}
              </>
            ) : (
              <Text>-</Text>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};
export { InformationList };
